import { render, staticRenderFns } from "./ViolationRecordsInfoDialog.vue?vue&type=template&id=0e545b5a&scoped=true"
import script from "./ViolationRecordsInfoDialog.vue?vue&type=script&lang=js"
export * from "./ViolationRecordsInfoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e545b5a",
  null
  
)

export default component.exports